export const districts = [
  // Tier 1 — Premium & High-Value Locations
  { id: 'd1', name: 'Asokoro', tier: 1 },
  { id: 'd2', name: 'Maitama', tier: 1 },
  { id: 'd3', name: 'Maitama Hill', tier: 1 },
  { id: 'd4', name: 'Aso Drive', tier: 1 },
  { id: 'd5', name: 'Guzape', tier: 1 },
  { id: 'd6', name: 'Katampe 1', tier: 1 },
  { id: 'd7', name: 'Katampe 2', tier: 1 },
  // Tier 2 — Upper-Mid Value Locations
  { id: 'd8', name: 'Apo', tier: 2 },
  { id: 'd9', name: 'Gudu', tier: 2 },
  { id: 'd10', name: 'Wuse Zone 1', tier: 2 },
  { id: 'd11', name: 'Wuse Zone 2', tier: 2 },
  { id: 'd12', name: 'Jabi', tier: 2 },
  { id: 'd13', name: 'LifeCamp', tier: 2 },
  { id: 'd14', name: 'Gwarimpa', tier: 2 },
  { id: 'd15', name: 'Wuye', tier: 2 },
  // Tier 3 — Growing & Residential Hubs
  { id: 'd16', name: 'Kuje', tier: 3 },
  { id: 'd17', name: 'Karsana', tier: 3 },
  { id: 'd18', name: 'Idu', tier: 3 },
  { id: 'd19', name: 'Kubwa', tier: 3 },
  { id: 'd20', name: 'Lugbe', tier: 3 },
  { id: 'd21', name: 'Kado', tier: 3 },
  { id: 'd22', name: 'Karu', tier: 3 },
  { id: 'd23', name: 'Durumi', tier: 3 },
]

// Listing fees per tier, split by seller type — matches AMU brief
export const listingFees = {
  1: { individual: 300000, company: 250000 },
  2: { individual: 150000, company: 150000 },
  3: { individual: 50000, company: 50000 },
} as const

export const properties = [
  {
    id: 'p1',
    title: 'Luxury 5-Bedroom Detached Duplex',
    price: 450000000,
    district: 'Maitama',
    tier: 1,
    type: 'House',
    size: '850 sqm',
    ownership: 'C of O',
    bedrooms: 5,
    bathrooms: 6,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Premium Homes Ltd',
      isVerified: true,
      type: 'Company',
    },
  },
  {
    id: 'p2',
    title: 'Prime Commercial Land',
    price: 850000000,
    district: 'Guzape',
    tier: 1,
    type: 'Land',
    size: '2000 sqm',
    ownership: 'FCDA Allocation',
    bedrooms: 0,
    bathrooms: 0,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1542621334-a254cf47733d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Abuja Real Estate Partners',
      isVerified: true,
      type: 'Company',
    },
  },
  {
    id: 'p3',
    title: 'Modern 4-Bedroom Terrace',
    price: 180000000,
    district: 'Jabi',
    tier: 2,
    type: 'House',
    size: '450 sqm',
    ownership: 'Deed of Assignment',
    bedrooms: 4,
    bathrooms: 4,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600210491892-03d54c0aaf87?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'John Doe',
      isVerified: true,
      type: 'Individual',
    },
  },
  {
    id: 'p4',
    title: 'Spacious 3-Bedroom Apartment',
    price: 85000000,
    district: 'Gwarimpa',
    tier: 2,
    type: 'Apartment',
    size: '250 sqm',
    ownership: 'C of O',
    bedrooms: 3,
    bathrooms: 3,
    isVerified: false,
    verificationStatus: 'Pending',
    images: [
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600573472556-e636c2acda88?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Jane Smith',
      isVerified: false,
      type: 'Individual',
    },
  },
  {
    id: 'p5',
    title: 'Affordable Plot of Land',
    price: 25000000,
    district: 'Lugbe',
    tier: 3,
    type: 'Land',
    size: '600 sqm',
    ownership: 'Right of Occupancy',
    bedrooms: 0,
    bathrooms: 0,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Lugbe Properties',
      isVerified: true,
      type: 'Company',
    },
  },
  {
    id: 'p6',
    title: 'Contemporary 5-Bed Mansion',
    price: 600000000,
    district: 'Asokoro',
    tier: 1,
    type: 'House',
    size: '1200 sqm',
    ownership: 'C of O',
    bedrooms: 5,
    bathrooms: 6,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600566753086-00f18fe6ba66?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Elite Homes',
      isVerified: true,
      type: 'Company',
    },
  },
  {
    id: 'p7',
    title: 'Executive 4-Bedroom Semi-Detached',
    price: 220000000,
    district: 'Maitama Hill',
    tier: 1,
    type: 'House',
    size: '500 sqm',
    ownership: 'C of O',
    bedrooms: 4,
    bathrooms: 5,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1568667256549-094345857637?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600585152220-90363fe7e115?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Capital Realty',
      isVerified: true,
      type: 'Company',
    },
  },
  {
    id: 'p8',
    title: 'Modern Bungalow with Garden',
    price: 65000000,
    district: 'Kubwa',
    tier: 3,
    type: 'House',
    size: '400 sqm',
    ownership: 'Deed of Assignment',
    bedrooms: 3,
    bathrooms: 3,
    isVerified: true,
    verificationStatus: 'Approved',
    images: [
      'https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&q=80&w=800',
      'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?auto=format&fit=crop&q=80&w=800',
    ],
    seller: {
      name: 'Greenfield Properties',
      isVerified: true,
      type: 'Company',
    },
  },
]

export const formatNaira = (amount: number) => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    maximumFractionDigits: 0,
  }).format(amount)
}

export const mockUsers = [
  {
    id: 'u1',
    name: 'John Doe',
    type: 'Buyer',
    verification: 'Verified',
    listings: 0,
    joined: 'Oct 12, 2023',
    status: 'Active',
  },
  {
    id: 'u2',
    name: 'Premium Homes Ltd',
    type: 'Company',
    verification: 'Verified',
    listings: 12,
    joined: 'Sep 05, 2023',
    status: 'Active',
  },
  {
    id: 'u3',
    name: 'Jane Smith',
    type: 'Owner',
    verification: 'Pending',
    listings: 2,
    joined: 'Oct 20, 2023',
    status: 'Active',
  },
  {
    id: 'u4',
    name: 'Suspicious User',
    type: 'Owner',
    verification: 'Rejected',
    listings: 0,
    joined: 'Oct 24, 2023',
    status: 'Suspended',
  },
]

export const mockInspections = [
  {
    id: 'i1',
    property: properties[0],
    date: '2023-10-25',
    time: '10:00 AM',
    status: 'Confirmed',
    seller: 'Premium Homes Ltd',
  },
  {
    id: 'i2',
    property: properties[2],
    date: '2023-10-26',
    time: '02:00 PM',
    status: 'Pending',
    seller: 'John Doe',
  },
  {
    id: 'i3',
    property: properties[4],
    date: '2023-10-20',
    time: '11:00 AM',
    status: 'Completed',
    seller: 'Lugbe Properties',
  },
]

export const mockConversations = [
  {
    id: 'c1',
    participant: { name: 'Premium Homes Ltd', avatar: 'P', type: 'Seller' },
    property: properties[0],
    lastMessage: 'Yes, the C of O is available for inspection.',
    time: '10:42 AM',
    unread: 2,
    messages: [
      {
        id: 'm1',
        sender: 'me',
        text: 'Hi, I am interested in the Maitama duplex. Is the title document verified?',
        time: '10:30 AM',
      },
      {
        id: 'm2',
        sender: 'them',
        text: 'Hello John! Yes, it is fully verified by AGIS.',
        time: '10:35 AM',
      },
      {
        id: 'm3',
        sender: 'them',
        text: 'Yes, the C of O is available for inspection.',
        time: '10:42 AM',
      },
    ],
  },
  {
    id: 'c2',
    participant: { name: 'Jane Smith', avatar: 'J', type: 'Seller' },
    property: properties[3],
    lastMessage: 'When would you like to visit?',
    time: 'Yesterday',
    unread: 0,
    messages: [
      {
        id: 'm1',
        sender: 'me',
        text: 'Is the Gwarinpa apartment still available?',
        time: 'Yesterday 09:00 AM',
      },
      {
        id: 'm2',
        sender: 'them',
        text: 'Yes it is! When would you like to visit?',
        time: 'Yesterday 09:15 AM',
      },
    ],
  },
]

export const mockFraudAlerts = [
  {
    id: 'f1',
    type: 'Duplicate Title',
    property: 'Luxury 5-Bed Duplex',
    seller: 'Suspicious User',
    severity: 'Critical',
    date: 'Oct 24, 2023',
    status: 'New',
  },
  {
    id: 'f2',
    type: 'Price Anomaly',
    property: 'Prime Commercial Land',
    seller: 'Unknown Agent',
    severity: 'Medium',
    date: 'Oct 23, 2023',
    status: 'Investigating',
  },
  {
    id: 'f3',
    type: 'Identity Mismatch',
    property: '3-Bed Apartment',
    seller: 'Jane Smith',
    severity: 'High',
    date: 'Oct 22, 2023',
    status: 'Resolved',
  },
]

export const mockTransactions = [
  {
    id: 'TXN-8492',
    user: 'Premium Homes Ltd',
    tier: 'Tier 1',
    amount: 300000,
    status: 'Success',
    date: 'Oct 24, 2023',
  },
  {
    id: 'TXN-8493',
    user: 'John Doe',
    tier: 'Tier 2',
    amount: 150000,
    status: 'Success',
    date: 'Oct 23, 2023',
  },
  {
    id: 'TXN-8494',
    user: 'Jane Smith',
    tier: 'Tier 3',
    amount: 50000,
    status: 'Failed',
    date: 'Oct 22, 2023',
  },
  {
    id: 'TXN-8495',
    user: 'Lugbe Properties',
    tier: 'Tier 3',
    amount: 50000,
    status: 'Success',
    date: 'Oct 21, 2023',
  },
]
